import { render, staticRenderFns } from "./GroupbuyingsCreateOrEdit.vue?vue&type=template&id=04386e33&"
import script from "./GroupbuyingsCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./GroupbuyingsCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupbuyingsCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports